<template>
    <div class="profile">
        <Person
            class="profile-list"
            v-for="person in persons"
            :key="person.id"
            :person="person"
        >
        </Person>
    </div>
</template>

<script>
import Person from '@/components/Person.vue';
import profileData from '@/data/profile.js';

export default {
    data: function() {
        return {
            persons: null,
        }
    },
    components: {
        Person,
    },
    methods: {
    },
    created: function() {
        this.persons = profileData;
    },
}
</script>

<style lang="scss" scoped>
.profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.profile-list{
    width: 50%;
    min-width: 650px;
    margin-bottom: 20px;
}
</style>

